<template>
  <span
    class="t-icon"
    :class="[
      `t-icon--${type}`,
      { 't-icon--boxed': boxed },
    ]"
  >
    <font-awesome-icon
      :icon="icon"
      :size="size"
      :fixed-width="fixedWidth"
      :rotation="rotation"
      :flip="flip"
      :spin="spin"
      :pulse="pulse"
      :border="border"
      :pull="pull"
      :inverse="inverse"
      :swap-opacity="swapOpacity"
      :mask="mask"
    >
    </font-awesome-icon>
  </span>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { iconFlipOptions, iconPullOptions, iconSizes } from '../../enums';

import ColorTypeMixin from '../../mixins/ColorTypeMixin';

library.add(fas, fab, far);

export default {
  name: 't-icon',
  mixins: [ColorTypeMixin],
  props: {
    boxed: Boolean,
    icon: {
      type: [String, Array],
      required: true,
    },
    size: {
      type: String,
      validator: (value) => Object.values(iconSizes).includes(value),
    },
    fixedWidth: Boolean,
    rotation: String,
    flip: {
      type: String,
      validator: (value) => Object.values(iconFlipOptions).includes(value),
    },
    spin: Boolean,
    pulse: Boolean,
    border: Boolean,
    pull: {
      type: String,
      validator: (value) => Object.values(iconPullOptions).includes(value),
    },
    inverse: Boolean,
    swapOpacity: Boolean,
    mask: [String, Array],
  },
  components: {
    FontAwesomeIcon,
  },
};
</script>
